import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["cancelStarted"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { BMEventsType } from '../types';
import { MetricState } from './base-metric';
import { BasePageLoadMetric } from './base-page-load-metric';
export var PageLoadMetaMetric = /*#__PURE__*/function (_BasePageLoadMetric) {
  function PageLoadMetaMetric() {
    var _this;
    _classCallCheck(this, PageLoadMetaMetric);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PageLoadMetaMetric, [].concat(args));
    _defineProperty(_this, "activePageLoadMetric", null);
    return _this;
  }
  _inherits(PageLoadMetaMetric, _BasePageLoadMetric);
  return _createClass(PageLoadMetaMetric, [{
    key: "startPageLoad",
    value: function startPageLoad() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isInitial: false,
        cancelStarted: false
      };
      var cancelStarted = _ref.cancelStarted,
        startPageLoadParams = _objectWithoutProperties(_ref, _excluded);
      if (cancelStarted || this.state !== MetricState.STARTED) {
        _superPropGet(PageLoadMetaMetric, "startPageLoad", this, 3)([startPageLoadParams]);
      }
    }
  }, {
    key: "setActive",
    value: function setActive(metric) {
      this.activePageLoadMetric = metric;
    }
  }, {
    key: "setDebug",
    value: function setDebug(debug) {
      this.config.debug = debug;
    }
  }, {
    key: "isDebugMode",
    value: function isDebugMode() {
      return this.config.debug;
    }
  }, {
    key: "isInitialLoad",
    value: function isInitialLoad() {
      return this.isInitial;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.activePageLoadMetric && this.activePageLoadMetric.cancel();
      _superPropGet(PageLoadMetaMetric, "clear", this, 3)([]);
    }
  }, {
    key: "include",
    value: function include(metric) {
      if (!this.config.include) {
        this.config.include = [metric];
      } else {
        this.config.include.push(metric);
      }
    }
  }, {
    key: "experimental__addExplicitTiming",
    value: function experimental__addExplicitTiming(name, timing) {
      if (this.explicitTimings === null) {
        this.explicitTimings = {};
      }
      this.explicitTimings[name] = timing;
    }
  }]);
}(BasePageLoadMetric);
export var pageLoadMetaMetric = new PageLoadMetaMetric({
  type: BMEventsType.PAGE_LOAD,
  key: 'page_load_meta_metric'
});